import React, { useState } from "react";
import './Consultoria.css';
import ImagenConsultoria from '../assets/images/Consultoria.jpg';
import Facebok from '../assets/images/Facebok.png';
import Wasa from '../assets/images/Wasa.png';
import insta from '../assets/images/insta.png';
import Ubi from '../assets/images/Ubi.png';
import Telefono from '../assets/images/Telefono.png';
import Email34 from '../assets/images/Correo.png';
import RedesFondo from '../assets/images/Red-Neuronal.png';
import checkAnim from '../assets/images/check.gif';

// Imágenes del menú visual
//Imagen frente item 1 Industria Alimentaria
import Ali from '../assets/images/Alimentos.webp';
import Car from '../assets/images/Carnicos.jpg';
import Manu from '../assets/images/Manufactura.jpg';
import Alu from '../assets/images/Aliminio.png';
import Com from '../assets/images/Comercializadora.webp';
import Aut from '../assets/images/Automotriz.jpg';
import ImagenBannerAsesoria from '../assets/images/Asesoria-Empresarial22.jpg';

const items = [
  //Item 1 Industria Alimntaria
    {
  //titulo frente ítem 1 Industria Alimentaria
    titulo: "Alimentos",
    imagen: Ali,
    //Imagen trasera ítem 1 Industria Alimentaria
    imagenDetalle: require('../assets/images/Industria3.webp'), 
   //Icono frente ítem 1 Industria Alimentaria
   //Icono atrás ítem 1 Industria Alimentaria
    icono: require('../assets/images/Ali.icono2.png'),
    descripcion: "Soluciones para mejorar procesos en la industria de alimentos con trazabilidad, seguridad e inocuidad.",
  },
  {
    //ítem 2 cárnicos
    //titulo frente ítem 2 cárnicos.
    titulo: "Cárnicos",
    //Imagen frente ítem 2 cárnicos.
    imagen: Car,
    //Imagen parte trasera ítem 2 cárnicos
    //Icono atrás ítem 2 cárnicos.
    imagenDetalle: require('../assets/images/Carnicos2.jpg'),
    //Icono frente ítem 2 cárnicos.
    icono: require('../assets/images/Carnica.png'),
    //Descripción trasera ítem 2 cárnicos.
    descripcion: "Gestión integral en plantas de procesamiento cárnico: inventarios, producción y calidad.",
  },
  {
    // ítem 3 Manufactura
    //Icono frente ítem 3 Manufactura
    titulo: "Metalmecanico",
    //Imagen frente ítem 3 Manufactura.
    imagen: Manu,
    //Imagen parte trasera ítem 3 Manufactura
    imagenDetalle: require('../assets/images/Manufactura2.jpeg'),
    //Icono frente ítem 3 Manufactura
    //Icono atrás ítem 3 Manufactura.
    icono: require('../assets/images/Manufa-icon.png'),
    //Descripción trasera ítem 3 Manufactura.
    descripcion: "Automatiza y controla procesos industriales en tiempo real con soluciones ERP especializadas.",
  },
  {
    // ítem 4 Aluminio.
    //titulo frente ítem 4 Aluminio.
    titulo: "Aluminio",
    //Imagen frente ítem 4 Aluminio.
    imagen: Alu,
    //Imagen parte trasera ítem 4 Aluminio.
    imagenDetalle: require('../assets/images/Aluminio.jpg'),
    //Icono frente ítem 4 Aluminio.
    //Icono atrás ítem 4 Aluminio.
    icono: require('../assets/images/Aluminio-icon.png'),
     //Descripción trasera ítem 4 Aluminio.
    descripcion: "Gestión de materiales, tiempos y costos en empresas de transformación de aluminio.",
  },
  {
    // ítem 5 Comercializadora.
    //titulo frente 5 Comercializadora.
    titulo: "Comercializadora",
    //Imagen frente ítem 5 Comercializadora.
    imagen: Com,
    //Imagen parte trasera ítem 5 Comercializadora.
    imagenDetalle: require('../assets/images/Comercializadora2.png'),
    //Icono frente ítem 5 Comercializadora.
    //Icono atrás ítem 5 Comercializadora.
    icono: require('../assets/images/Comer-icon.png'),
 //Descripción trasera ítem 5 Comercializadora.
    descripcion: "Optimización de logística, almacenes y ventas para empresas distribuidoras y mayoristas.",
  },
  {
    // ítem 6 Automotriz.
    //titulo frente ítem 6 Automotriz.
    titulo: "Automotriz",
    //Imagen frente ítem 6 Automotriz.
    imagen: Aut,
    //Imagen parte trasera ítem 6 Automotriz.
    imagenDetalle: require('../assets/images/Automotriz2.jpg'),
    //Icono frente ítem 6 Automotriz.
    //Icono atrás ítem 6 Automotriz.
    icono: require('../assets/images/Auto-icon.png'),
    //Descripción trasera ítem 6 Automotriz.
    descripcion: "Control de calidad, mantenimiento y cadena de suministro para el sector automotriz.",
  },
];

function Consultoria() {
  const [activo, setActivo] = useState(null);

  const [enviado, setEnviado] = useState(false);
    
      const handleSubmit = (e) => {
        e.preventDefault();
        const form = e.target;
    
        fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
        }).then(() => {
          setEnviado(true);
          form.reset();
          // Opcional: volver a mostrar formulario después de 5s
          // setTimeout(() => setEnviado(false), 5000);
        });
      };

  return (
    <>
       {/*Inicio Asesoría Empresarial*/}
<div className="infra-banner2">
  {/* Imagen en la sección de Inicio Asesoría Empresarial*/}
  <img src={ImagenBannerAsesoria} alt="Asesoria Empresarial" className="banner-img2" />
  {/*Titulo Asesoría Empresarial Sección Inicio  */}
    <h1 className="banner-texto2">Asesoria Empresarial</h1>
</div>

{/*Bloque introducción Asesoría Empresarial*/}
<div className="infra-descripcion2">
  {/*Descripción Sección Asesoría Empresarial*/}
  <p>
    Brindamos asesoría especializada para optimizar procesos empresariales e implementar sistemas ERP;<br></br> 
    adaptandolos a las necesidades de tu grupo empresarial.
  </p>
</div>

{/*Menú Asesoría Empresarial*/}
<div className="contenedor-menu">
  {/*Titulo Menu Asesoría Empresarial Sección Inicio  */}
  <h2 className="menu-titulo">Algunas industrias que han confiado<br></br>
   en nuestra asesoría ...</h2>
<div className="menu-industria">
  
  {items.map((item, idx) => (
    <div
      key={idx}
      className={`flip-card ${activo === idx ? 'active' : ''}`}
      onClick={() => setActivo(activo === idx ? null : idx)}
    >
      <div className="flip-card-inner">
        
        {/* CARA FRONTAL */}
        <div
          className="flip-card-front"
          style={{
            backgroundImage: `url(${item.imagen})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <div className="contenido-front">
            {item.icono && (
              <img src={item.icono} alt="ícono" className="icono-front" />
            )}
            <h3 className="titulo-front">{item.titulo}</h3>
          </div>
        </div>

        {/* CARA TRASERA */}
        <div
          className="flip-card-back"
          style={{
            backgroundImage: `url(${item.imagenDetalle})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <div className="contenido-back">
            {item.icono && (
              <img src={item.icono} alt="ícono" className="icono-back" />
            )}
            <p>{item.descripcion}</p>
          </div>
        </div>

      </div>
    </div>
  ))}
</div>
 </div>



{/* Contenedor principal del formulario de contacto*/}
 <div className="formulario-imagen-style20">
  <div className="linea-superior20"></div>

  {/*Titulo Formulario*/}
  <h2>

  {!enviado ? (
    'Contáctanos para más información'
  ) : (
    <>
      ¡¡¡ GRACIAS POR CONTACTARNOS !!!<br />
        Un especialista se pondrá en contacto contigo.
    </>
  )}
</h2>

  {!enviado ? (
    <form
      onSubmit={handleSubmit}
      action="https://formsubmit.co/ivan.benitez@iatekza.com"
      method="POST"
      className="formulario-simple20"
    >
      <input type="hidden" name="_captcha" value="false" />
{/* Campos de entrada para nombre, teléfono, correo, empresa y mensaje */}

      {/* Campo nombre*/}
      <input type="text" name="nombre" placeholder="Nombre" required />
      {/* Campo Número Telefónico */}
      <input type="tel" name="numero" placeholder="Número Telefónico" required />
      {/* Campo Correo Electronico*/}
      <input type="email" name="correo" placeholder="Correo Electrónico" required />
      {/* Campo Empresa*/}
      <input type="text" name="empresa" placeholder="Empresa (Opcional)" />
      {/* Campo Mensaje*/}
      <textarea name="mensaje" placeholder="Mensaje" required></textarea>
      {/* Botón de envío del formulario*/}
      <button type="submit">Enviar</button>
    </form>
  ) : (
    <div className="confirmacion-envio20">
      {/* gift al enviar formulario */}
      <img src={checkAnim} alt="Éxito" />
      {/* Texto abajo al enviar*/}
      <p>¡ Mensaje enviado correctamente !</p>
    </div>
  )}
</div>



{/* Contenedor principal  de pie de página con contacto*/}
<div className="contacto-footer-nuevo">
  <div className="footer-contenido-nuevo">
    {/* Fondo completo con redes */}
  <img src={RedesFondo} alt="Fondo redes" className="redes-fondo-completa" />
    {/* Columna 1: Contacto */}
    <div className="footer-columna-nueva">
  <h4>CONTACTO GRUPO IATEKZA</h4>
{/* Ubicación contacto*/}
  <div className="footer-item">
    <img src={Ubi} alt="Ubi" className="footer-icono" />
    <p>Circon 5, Colonia El Pedregal de <br /> Atizapán, Estado de México, C.P. 52948.</p>
  </div>
{/* Numero contacto*/}
  <div className="footer-item">
    <img src={Telefono} alt="Teléfono" className="footer-icono" />
    <p>+52 55 5335 5810</p>
  </div>
{/* Correo contacto*/}
  <div className="footer-item">
    <img src={Email34} alt="Correo" className="footer-icono" />
    <p>ventas@iatekza.com</p>
  </div>
</div>


    {/* Columna 2: Servicios */}
    <div className="footer-columna-nueva">
      <h4>Conoce nuestros servicios</h4>
      <ul>
        {/* IAutomatiza CFDI Colum 2*/}
        <li><a href="/">• IAutomatiza CFDI</a></li>
        {/*Facturacion Electronica Colum 2*/}
        <li><a href="/Facturacion">• Facturación Electronica</a></li>
        {/* Servicio infraestructura TI colum 2*/}
        <li><a href="/Comercializacion">• Infraestructura TI</a></li>
        {/* Servicio Soluciones Tecnológicas colum 2*/}
        <li><a href="/Sistemas">• Soluciones Tecnologícas</a></li>
      </ul>
      {/*Facebook Colum 2*/}
      <div className="iconos-redes-nuevos">
        <a href="https://www.facebook.com/profile.php?id=61577085653032&locale=es_LA/" target="_blank" rel="noopener noreferrer">
          <img src={Facebok} alt="Facebook" />
        </a>
        {/*Wasak Colum 2*/}
        <a href="https://api.whatsapp.com/send?phone=5215567786252&text=Hola, me gustaría más información acerca de:" target="_blank" rel="noopener noreferrer">
          <img src={Wasa} alt="WhatsApp" />
        </a>
        {/*Instagram Colum 2*/}
        <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
          <img src={insta} alt="Instagram" />
        </a>
      </div>
    </div>

    {/* Columna 3: Información general */}
    <div className="footer-columna-nueva">
      <h4>Información General</h4>
      <ul>
         {/*Sobre Nosotros Colum 3*/}
        <li><a href="/Nosotros">Sobre nosotros</a></li>
         {/*Casos de Exito Colum 3*/}
        <li><a href="/CasosExito">Casos de Éxito</a></li>
         {/*Aviso Legal Colum 3*/}
        <li><a href="/servicios#facturacion">Aviso Legal</a></li>
        {/*Servicios Colum 3*/}
      </ul>
    </div>
  </div>

{/*Línea de derechos reservados */}
  <div className="footer-bottom-nuevo">
    <p>© Grupo IAtekza 2025 – Todos los derechos reservados</p>
  </div>
</div>
    </>
  );
}

export default Consultoria;



